import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useRef, useState } from "react";
import { ClickAwayListener } from "@fidget/common/components/form/clickAwayListener";
import {
  Choice,
  TripleDatePicker
} from "@fidget/common/components/form/tripleDatePicker/tripleDatePicker";
import { L10n } from "@fidget/common/i18n";
import { useStore } from "../../../../models";
import {
  GlobalFilterTypes,
  IFilterAnyThreadClosed
} from "../../../../models/inbox/ConcreteGlobalFilters";
import filterStyles from "../expandedFilters.css";
import { endOfDay, format, startOfDay } from "date-fns";
import styles from "./filters.css";

interface Props {
  resetState(): void;
}

export const ThreadClosedFilter = observer(({ resetState }: Props) => {
  const { inboxStore } = useStore();
  const entryRef = useRef<HTMLDivElement>();
  const [isPickingDate, setIsPickingDate] = useState(false);
  const filter = inboxStore.globalFilter.getFilter(GlobalFilterTypes.AnyThreadClosedAt) as
    | IFilterAnyThreadClosed
    | undefined;

  const handleDateChosen = (choice: Choice) => {
    const pickedDate = new Date(choice.year, choice.month - 1, choice.day);
    inboxStore.globalFilter.activateAnyThreadClosedFilter(
      +startOfDay(pickedDate),
      +endOfDay(pickedDate)
    );
    resetState();
  };

  const handleClicked = () => {
    if (!isPickingDate) {
      if (!!filter) {
        inboxStore.globalFilter.deactivateFilter(GlobalFilterTypes.AnyThreadClosedAt);
        return;
      }
    }
    setIsPickingDate(!isPickingDate);
  };

  const renderDatePicker = () => {
    return (
      <ClickAwayListener onClickAway={() => setIsPickingDate(false)} insideTargetDivs={[entryRef]}>
        <TripleDatePicker onDatePicked={handleDateChosen} />
      </ClickAwayListener>
    );
  };

  return (
    <div
      className={classNames(styles["date-filter"])}
      ref={(el) => (entryRef.current = el || undefined)}
    >
      <div
        onClick={handleClicked}
        className={classNames(styles.entry, { [styles.selected]: !!filter && !isPickingDate })}
      >
        <div>
          <L10n id="inbox.moreFilters.global.withThreadClosedAt" />
          {filter && (
            <p className={filterStyles["entry-desc"]}>{format(filter.after, "dd - MM - yyyy")}</p>
          )}
        </div>
        {filter && (
          <div className={filterStyles.applied}>
            <L10n id={"inbox.moreFilters.applied"} />
          </div>
        )}
      </div>
      {isPickingDate && renderDatePicker()}
    </div>
  );
});
